var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportTool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3097_23626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6799 13.5339H11.4802V12.38C11.4802 12.1177 11.2671 11.9048 11.0045 11.9048C10.742 11.9048 10.5289 12.1177 10.5289 12.38V13.5339H9.32919C9.06662 13.5339 8.85352 13.7468 8.85352 14.0091C8.85352 14.2715 9.06662 14.4844 9.32919 14.4844H10.5289V15.6382C10.5289 15.9006 10.742 16.1135 11.0045 16.1135C11.2671 16.1135 11.4802 15.9006 11.4802 15.6382V14.4844H12.6799C12.9424 14.4844 13.1555 14.2715 13.1555 14.0091C13.1555 13.7468 12.9424 13.5339 12.6799 13.5339Z",
    fill: "white",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0045 10.0181C8.80212 10.0181 7.00977 11.8088 7.00977 14.0091C7.00977 16.2094 8.80212 18.0001 11.0045 18.0001C13.2069 18.0001 14.9992 16.2094 14.9992 14.0091C14.9992 11.8088 13.2069 10.0181 11.0045 10.0181ZM11.0045 17.0496C9.32631 17.0496 7.96112 15.6857 7.96112 14.0091C7.96112 12.3325 9.32631 10.9685 11.0045 10.9685C12.6827 10.9685 14.0479 12.3325 14.0479 14.0091C14.0479 15.6857 12.6827 17.0496 11.0045 17.0496Z",
    fill: "white",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87639 16.7748H0.951354V2.46172H3.13471V4.57461H10.8863V2.46172H13.0697V9.49044C13.4093 9.64537 13.728 9.83736 14.0211 10.0617V1.98648C14.0211 1.72415 13.808 1.51125 13.5454 1.51125H9.16344C8.84379 0.631112 7.99994 0 7.01053 0C6.02112 0 5.17632 0.631112 4.85761 1.51125H0.475677C0.213103 1.51125 0 1.72415 0 1.98648V17.2501C0 17.5124 0.213103 17.7253 0.475677 17.7253H7.70977C7.39392 17.4449 7.11327 17.1265 6.87639 16.7748ZM7.01053 1.52075C7.43388 1.52075 7.77732 1.86482 7.77732 2.28778C7.77732 2.34766 7.76971 2.40564 7.75639 2.46172C7.67743 2.80008 7.37299 3.05386 7.01053 3.05386C6.64806 3.05386 6.34363 2.80008 6.26372 2.46172C6.2504 2.40564 6.24279 2.34766 6.24279 2.28778C6.24279 1.86482 6.58718 1.52075 7.01053 1.52075Z",
    fill: "white",
    fillOpacity: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3097_23626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportTool);
export default __webpack_public_path__ + "static/media/support_tool.79bc7895.svg";
export { ForwardRef as ReactComponent };